import request from '@/utils/request'

export function getListByProduct(data) {
  return request({
    url: '/Api/brand.FreightTemplate/getListByProduct',
    method: 'post',
    data
  })
}

export function getCity(data) {
  return request({
    url: '/Api/brand.FreightTemplate/getCity',
    method: 'post',
    data
  })
}

export function getList(data){
	return request({
		url: '/Api/brand.FreightTemplate/getList',
		method: 'post',
		data
	})
}

export function getRelatedProductNum(data){
	return request({
		url: '/Api/brand.FreightTemplate/getRelatedProductNum',
		method: 'post',
		data
	})
}

export function delFreightTemplate(data){
	return request({
		url: '/Api/brand.FreightTemplate/delFreightTemplate',
		method: 'post',
		data
	})
}

export function getRelatedProductInfo(data){
	return request({
		url: '/Api/brand.FreightTemplate/getRelatedProductInfo',
		method: 'post',
		data
	})
}

export function addOrEditTemplate(data){
	return request({
		url: '/Api/brand.FreightTemplate/addOrEdit',
		method: 'post',
		data
	})
}

export function getDetail(data){
	return request({
		url: '/Api/brand.FreightTemplate/getFreightTemplateDetail',
		method: 'post',
		data
	})
}